module.exports = __webpack_public_path__ + "img/MacAppStore.30f80d56.png";